import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "./defaults";

const ContentContext = createContext(DEFAULT_CONTENT);
const ReadyContext = createContext(false);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then(({ data }) => {
        const origin = process.env.REACT_APP_BACKEND_URL;
        const fixed = JSON.parse(
          JSON.stringify(data).replace(/https?:\/\/[^/"]+(\/api\/files\/)/g, `${origin}$1`)
        );
        setContent({ ...DEFAULT_CONTENT, ...fixed });
      })
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  return (
    <ReadyContext.Provider value={ready}>
      <ContentContext.Provider value={content}>
        {children}
      </ContentContext.Provider>
    </ReadyContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
export const useContentReady = () => useContext(ReadyContext);
